import { requestApi } from './Api';

export const updateInvoices = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/appointment/invoices/update',
    params
  });

export const updateSingleInvoice = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practice/billing/invoicing/internal/update',
    params
  });
